module.exports = __webpack_public_path__ + "static/media/1POLICY3.6330a676.jpg";